"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var assert_1 = require("@0x/assert");
var custom_order_provider_1 = require("./order_provider/custom_order_provider");
var mesh_order_provider_1 = require("./order_provider/mesh_order_provider");
var sra_polling_order_provider_1 = require("./order_provider/sra_polling_order_provider");
var sra_websocket_order_provider_1 = require("./order_provider/sra_websocket_order_provider");
var order_store_1 = require("./order_store");
var Orderbook = /** @class */ (function () {
    /**
     * Creates an Orderbook with the order provider. All order updates are stored
     * in the `OrderStore`.
     * @param orderProvider the order provider, e.g SRAWebbsocketOrderProvider
     * @param orderStore the order store where orders are added and deleted
     */
    function Orderbook(orderProvider, orderStore) {
        this._orderProvider = orderProvider;
        this._orderStore = orderStore;
    }
    /**
     * Creates an Orderbook with the provided orders. This provider simply stores the
     * orders and allows querying. No validation or subscriptions occur.
     * @param orders the set of SignedOrders
     */
    Orderbook.getOrderbookForProvidedOrders = function (orders) {
        var orderStore = new order_store_1.OrderStore();
        return new Orderbook(new custom_order_provider_1.CustomOrderProvider(orders, orderStore), orderStore);
    };
    /**
     * Creates an Orderbook with the SRA Websocket Provider. This Provider fetches orders via
     * the SRA http endpoint and then subscribes to the asset pair for future updates.
     * @param opts the `SRAWebsocketOrderProviderOpts`
     */
    Orderbook.getOrderbookForWebsocketProvider = function (opts) {
        var orderStore = new order_store_1.OrderStore();
        return new Orderbook(new sra_websocket_order_provider_1.SRAWebsocketOrderProvider(opts, orderStore), orderStore);
    };
    /**
     * Creates an Orderbook with SRA Polling Provider. This Provider simply polls every interval.
     * @param opts the `SRAPollingOrderProviderOpts`
     */
    Orderbook.getOrderbookForPollingProvider = function (opts) {
        var orderStore = new order_store_1.OrderStore();
        return new Orderbook(new sra_polling_order_provider_1.SRAPollingOrderProvider(opts, orderStore), orderStore);
    };
    /**
     * Creates an Orderbook with a Mesh Order Provider. This Provider fetches ALL orders
     * and subscribes to updates on ALL orders.
     * @param opts the `MeshOrderProviderOpts`
     */
    Orderbook.getOrderbookForMeshProvider = function (opts) {
        var orderStore = new order_store_1.OrderStore();
        return new Orderbook(new mesh_order_provider_1.MeshOrderProvider(opts, orderStore), orderStore);
    };
    /**
     * Returns all orders where the order.makerAssetData == makerAssetData and
     * order.takerAssetData == takerAssetData. This pair is then subscribed to
     * and all future updates will be stored. The first request
     * to `getOrdersAsync` might fetch the orders from the Order Provider and create a subscription.
     * Subsequent requests will be quick and up to date and synced with the Order Provider state.
     * @param makerAssetData the maker asset data
     * @param takerAssetData the taker asset data
     */
    Orderbook.prototype.getOrdersAsync = function (makerAssetData, takerAssetData) {
        return __awaiter(this, void 0, void 0, function () {
            var assetPairKey, orders;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        assert_1.assert.isString('makerAssetData', makerAssetData);
                        assert_1.assert.isString('takerAssetData', takerAssetData);
                        assetPairKey = order_store_1.OrderStore.getKeyForAssetPair(makerAssetData, takerAssetData);
                        if (!!this._orderStore.has(assetPairKey)) return [3 /*break*/, 2];
                        return [4 /*yield*/, this._orderProvider.createSubscriptionForAssetPairAsync(makerAssetData, takerAssetData)];
                    case 1:
                        _a.sent();
                        _a.label = 2;
                    case 2:
                        orders = this._orderStore.values(assetPairKey);
                        return [2 /*return*/, orders.filter(function (o) { return o.order.makerAssetData === makerAssetData && o.order.takerAssetData === takerAssetData; })];
                }
            });
        });
    };
    /**
     * Returns all of the Available Asset Pairs for the provided Order Provider.
     */
    Orderbook.prototype.getAvailableAssetDatasAsync = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this._orderProvider.getAvailableAssetDatasAsync()];
            });
        });
    };
    /**
     * Adds the orders to the Order Provider. All accepted orders will be returned
     * and rejected orders will be returned with an message indicating a reason for its rejection
     * @param orders The set of Orders to add to the Order Provider
     */
    Orderbook.prototype.addOrdersAsync = function (orders) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this._orderProvider.addOrdersAsync(orders)];
            });
        });
    };
    /**
     * Destroys any subscriptions or connections.
     */
    Orderbook.prototype.destroyAsync = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this._orderProvider.destroyAsync()];
            });
        });
    };
    return Orderbook;
}());
exports.Orderbook = Orderbook;
//# sourceMappingURL=orderbook.js.map